import { connect } from "react-redux"

import {
  forcePanelIndex,
  updateChoice,
  addToCart,
  trackSlide,
} from "areas/product/store/actions"
import limitChars from "helpers/product/limit-chars"

export default function withEngravings(WrappedComponent) {
  const InternalWithEngravings = (props) => {
    return <WrappedComponent {...props} />
  }

  const getSelectedFont = (state, ownProps) => {
    return state.choices[ownProps.pref || "ef"]
      ? state.choices[ownProps.pref || "ef"].value
      : ""
  }

  const getDisabledEngravings = (state) => {
    if (typeof state.choices !== "undefined") {
      return Object.keys(state.choices).filter(
        (key) => key[0] == "e" && state.choices[key].disabled
      )
    } else {
      return []
    }
  }

  const getEngravingValues = (state, ownProps) => {
    let values = {}
    if (
      !state.wizard.data[ownProps.pref || "ef"] ||
      !state.wizard.data[ownProps.pref || "ef"].engravings
    ) {
      return values
    }
    state.wizard.data[ownProps.pref || "ef"].engravings.forEach((engraving) => {
      if (typeof state.choices[engraving.pref] === "undefined") {
        values[engraving.pref] = ""
      } else {
        if (state.choices[engraving.pref].is_default) {
          values[engraving.pref] = ""
        } else {
          values[engraving.pref] = state.choices[engraving.pref].value || ""
        }
      }
    })
    return values
  }

  const getSelectedValue = (state, ownprops) => {
    if (typeof state.choices[ownprops.pref] === "undefined") {
      return ""
    } else {
      return state.choices[ownprops.pref].value
    }
  }

  const getErrorText = (state, ownProps) => {
    let errors = []
    if (
      !state.wizard.data[ownProps.pref || "ef"] ||
      !state.wizard.data[ownProps.pref || "ef"].engravings
    ) {
      return null
    }
    state.wizard.data[ownProps.pref || "ef"].engravings.forEach((engraving) => {
      if (
        typeof state.choices[engraving.pref] !== "undefined" &&
        state.choices[engraving.pref].error
      ) {
        errors.push(state.choices[engraving.pref].error)
      }
    })
    if (errors.length > 0) {
      return errors.map((s, i) => (
        <span key={i}>
          {s}
          <br />
        </span>
      ))
    } else {
      return null
    }
  }

  const getSelectedEngCount = (state) => {
    if (
      typeof state.choices !== "undefined" &&
      typeof state.choices.ec !== "undefined"
    ) {
      return state.choices.ec.value || ""
    } else {
      return ""
    }
  }

  const mapStateToProps = (state, ownProps) => {
    return {
      choices: state.choices,
      data: state.wizard.data[ownProps.pref || "ef"],
      disabledEngravings: getDisabledEngravings(state, ownProps),
      engravingValues: getEngravingValues(state, ownProps),
      errorText: getErrorText(state, ownProps),
      // images allows us to access the engraving previews for nameplates that don't show them in the
      // regular image views
      images: state.previewImage.data && state.previewImage.data.images,
      isAddingToCart: state.wizardUI.isAddingToCart,
      isMobile: state.browser.is.mobile,
      pref: ownProps.pref || "ef",
      productType: state.wizard.description.product_type,
      selectedEngCount: getSelectedEngCount(state, ownProps),
      selectedFont: getSelectedFont(state, ownProps),
      selectedValue: getSelectedValue(state, ownProps),
      styleCode: state.choices.style_code ? state.choices.style_code.value : "",
      wizardData: state.wizard.data,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      addToCart: (e, isAddingToCart) => {
        if (!isAddingToCart) {
          dispatch(addToCart())
        }
      },
      dispatch,
      forcePanelIndex: (idx) => {
        dispatch(forcePanelIndex(idx))
      },
      setEngCount: (e) => {
        const val = e.target.value
        try {
          dispatch(updateChoice("ec", { value: val }))
        } catch (err) {
          console.error(err)
        }
      },
    }
  }

  const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { choices, data, productType } = stateProps
    const { dispatch } = dispatchProps
    return {
      ...ownProps,
      ...stateProps,
      ...dispatchProps,
      setFont: (pref, fontData) => {
        dispatch(updateChoice(pref, fontData, true))
        data.engravings.forEach((engraving) => {
          limitChars(choices[engraving.pref], null, dispatch, null, true)
        })
        if (fontData.track_slide) {
          dispatch(trackSlide(fontData.track_slide))
        } else if (productType === "WATCH") {
          dispatch(trackSlide("b"))
        }
      },
    }
  }

  const WithEngravings = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(InternalWithEngravings)

  return WithEngravings
}
